import { t } from "@lingui/macro";
import { atom, useAtomValue, useSetAtom } from "jotai";

import { Button } from "@whoosh/design-system/src/components/controls";
import {
  ArrowLeftIcon,
  CloseIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { HStack } from "@whoosh/design-system/src/components/primitive";

import { GoBackToPreviousStepAtom } from "../atoms/actions";
import { UpdateEmailOrPhoneProfileStepStateAtom } from "../atoms/stores";

const shouldCloseOnBackPressAtom = atom((get) => {
  const state = get(UpdateEmailOrPhoneProfileStepStateAtom);
  return state.backStep === null;
});

export const UpdateEmailOrPhoneProfileHeader = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const shouldCloseOnBackPress = useAtomValue(shouldCloseOnBackPressAtom);
  const goBack = useSetAtom(GoBackToPreviousStepAtom);

  const handleButtonPress = () => {
    if (shouldCloseOnBackPress) {
      onClose();
    } else {
      goBack();
    }
  };

  return (
    <HStack
      mx={6}
      mt={6}
      pb={10}
      justifyContent={"space-between"}
      alignItems="center"
    >
      <Button
        onPress={handleButtonPress}
        accessibilityLabel={t`Back button`}
        variant="secondary"
        leftIcon={shouldCloseOnBackPress ? <CloseIcon /> : <ArrowLeftIcon />}
      />
    </HStack>
  );
};
